module.exports = __webpack_public_path__ + "img/dsci0010.d68c5100.jpg";